// 文章相关模块
import request from '@/utils/request'

// 获取最新文章
export const getArticlePage = params => {
  return request({
    method: 'GET',
    url: '​​/api/article/page',
    params
  })
}

// 获取热门文章
export const getPopularArticles = params => {
  return request({
    method: 'GET',
    url: '​​/api/article/popularArticles',
    params
  })
}

// 获取热词
export const getPopularWords = params => {
  return request({
    method: 'GET',
    url: '​​/api/article/popularWords',
    params
  })
}

// 获取文章详情
export const getArtcleDetail = params => {
  return request({
    method: 'GET',
    url: `/api/article/${params}`
  })
}
